/* eslint-disable react/prop-types */

import { Route } from 'react-router';
import {
  ELSCommonConfig,
  ELSCommonUIConstants,
  ELSStorageHelper
} from '@els/els-ui-common-react';
import { Redirect } from 'react-router-dom';
import { ReactNode } from 'react';
import { RecordObject } from '../../models/common.models';

type RouteConfig = {
  path: string;
  exact?: boolean;
  component: React.ComponentType<RecordObject>;
  data?: unknown;
  isPrivate?: boolean;
};

const createPrivateRoute = ({ component: Component, ...route }: RouteConfig): React.ReactElement => (
  <Route
    key={route.path}
    {...route}
    render={props =>
      (ELSStorageHelper.driver(ELSCommonConfig.storageDriver)
        .namespace(ELSCommonUIConstants.security.Locker.TokenNamespace)
        .get(ELSCommonUIConstants.security.Locker.TokenCacheKey) ? (
          <Component {...props} aaData={route.data} />
        ) : (
          <Redirect
            to={{
            pathname: `/${ELSCommonUIConstants.security.States.NotAuthorized}`,
            state: { from: props.location }
          }}
        />
        ))}
  />
);

export const createRoute = (route: RouteConfig): ReactNode => {
  const RouteComponent = route.component;
  const injectedRoute = { ...route, component: RouteComponent };
  if (injectedRoute.isPrivate) {
    return createPrivateRoute(injectedRoute);
  }
  return (
    <Route
      key={injectedRoute.path}
      path={injectedRoute.path}
      exact={injectedRoute.exact}
      render={props => <RouteComponent {...props} aaData={route.data} />}
    />
  );
};
